import React, { useEffect, useState, useRef } from 'react';
import { connect } from "react-redux";
import {
    DialogTitle, DialogContent, DialogActions, Dialog, makeStyles, Paper, ClickAwayListener, MenuList, MenuItem, Card, CardContent, Divider,
    Popper,
    Grow,
} from '@material-ui/core';
import Button from '@material-ui/core/Button';
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const useStyles = makeStyles((theme) => ({
    arrowDropDownIconV1: {
        marginTop: -3
    },
    filterButtonVehicle: {
        textTransform: "capitalize",
        padding: "5px 10px",
        backgroundColor: "#fff",
        fontWeight: 300,
        paddingLeft: 16,
    },
    wV1: {
        width: '100%'
    },
    menuItemV1: {
        display: 'flex', justifyContent: 'flex-start', fontWeight: 300, paddingTop: 10, paddingBottom: 10, textTransform: 'capitalize'
    },
    expandMoreIcon: {
        marginTop: -1,
        color: 'grey'
    }
}));

const ExpenseTypeFilter = ({ vehicle, filterValue, fromMaintenanceBook, fromDriverBook }) => {

    const [open, setOpen] = useState(false);
    const [expenseTypeFilterDisplayName, setExpenseTypeFilterDisplayName] = useState("All Expenses");
    const [expenseType, setExpenseType] = useState([]);

    const anchorRef = useRef(null);
    const prevOpen = useRef(open);

    const classes = useStyles();

    useEffect(() => {
        if (prevOpen.current === true && open === false) {
            anchorRef.current.focus();
        }

        prevOpen.current = open;
    }, []);

    useEffect(() => {
        if (vehicle.truckBooks && vehicle.truckBooks.expenseTypes && fromMaintenanceBook) {
            setExpenseType(vehicle.truckBooks.expenseTypes);
            vehicle.truckBooks.expenseTypes.unshift({ expenseName: "All Expense", expenseType: "All_Expense" });
        } else if (fromDriverBook && vehicle.truckBooks && vehicle.truckBooks.expenseTypes) {
            setExpenseType(vehicle.truckBooks.expenseTypes);
            vehicle.truckBooks.expenseTypes.unshift({ expenseName: "All Expense", expenseType: "All_Expense" });
        }
    }, [vehicle.truckBooks]);

    useEffect(() => {
        if (vehicle.defaultExpenseTypeFilterValue) {
            setExpenseTypeFilterDisplayName(vehicle.defaultExpenseTypeFilterValue);
        }
    }, [vehicle.defaultExpenseTypeFilterValue]);

    const handleItemClick = (value) => {
        setOpen(false);
        setExpenseTypeFilterDisplayName(value.expenseName);
        if (value.expenseType) {
            filterValue(value.expenseType);
        }
    }

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }

        setOpen(false);
    }

    const handleExpenseTypeFilterOpen = () => {
        setOpen(true);
    }

    return (
        <>
            <Button
                ref={anchorRef}
                aria-controls={open ? 'menu-list-grow' : undefined}
                aria-haspopup="true"
                variant="outlined"
                size="small"
                className={classes.filterButtonVehicle}
                onClick={handleExpenseTypeFilterOpen}
            >
                {expenseTypeFilterDisplayName}{" "}
                <ExpandMoreIcon className={classes.expandMoreIcon} />
            </Button>

            {
                open &&
                <Popper open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal style={{ zIndex: 1000 }}>
                    {({ TransitionProps, placement }) => (
                        <Grow
                            {...TransitionProps}
                            style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
                        >
                            <Paper>
                                <ClickAwayListener onClickAway={handleClose}>
                                    <MenuList autoFocusItem={open} id="menu-list-grow">
                                        {expenseType.map((value) => (

                                            < div className={classes.wV1} >
                                                < MenuItem className={classes.menuItemV1} onClick={() => handleItemClick(value)}><span>{value.expenseName}</span></MenuItem>
                                                <Divider light />
                                            </ div>

                                        ))}

                                    </MenuList>
                                </ClickAwayListener>
                            </Paper>
                        </Grow>
                    )}
                </Popper>
            }

        </>
    );
}

const mapStateToProps = (state) => ({ vehicle: state.vehicle });
export default connect(mapStateToProps)(ExpenseTypeFilter);